module.exports = __webpack_public_path__ + "static/img/bg-secondary-banner-smartSite-posterImg.132b8f98.png";